import { render, staticRenderFns } from "./TradingOrders.vue?vue&type=template&id=6769517e&scoped=true&"
import script from "./TradingOrders.vue?vue&type=script&lang=js&"
export * from "./TradingOrders.vue?vue&type=script&lang=js&"
import style0 from "./TradingOrders.vue?vue&type=style&index=0&id=6769517e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6769517e",
  null
  
)

export default component.exports